import { useEffect } from 'react'


// Установка CSS-переменной vh для корректного высчитывания размеров на моб.устройствах
const useDynamicVH = () => {
  useEffect(() => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
    let lastHeight = window.innerHeight
    let effectiveHeight = 0
    let ticking = false

    const updateVH = () => {
      const height = isIOS
        ? window.innerHeight // iOS не поддерживает visualViewport
        : window.visualViewport?.height ?? window.innerHeight

      const systemUIHeight =
        window.innerHeight - document.documentElement.clientHeight

      effectiveHeight = height - systemUIHeight

      if (effectiveHeight !== lastHeight) {
        lastHeight = effectiveHeight
        const vh1 = effectiveHeight * 0.01
        document.documentElement.style.setProperty('--vh100', `${effectiveHeight}px`)
        document.documentElement.style.setProperty('--vh1', `${vh1}px`)
      }

      ticking = false
    }

    const rafUpdateVH = () => {
      if (!ticking) {
        requestAnimationFrame(updateVH)
        ticking = true
      }
    }

    const addListeners = () => {
      if (isIOS) {
        // Для iOS используем scroll и orientationchange
        window.addEventListener('scroll', rafUpdateVH)
        window.addEventListener('orientationchange', rafUpdateVH)
      } else {
        // Для Android и других — visualViewport и resize
        window.visualViewport?.addEventListener('resize', rafUpdateVH)
        if (window.visualViewport) window.visualViewport.addEventListener('resize', rafUpdateVH)
      }
    }

    const removeListeners = () => {
      if (isIOS) {
        window.removeEventListener('scroll', rafUpdateVH)
        window.removeEventListener('orientationchange', rafUpdateVH)
      } else {
        window.visualViewport?.removeEventListener('resize', rafUpdateVH)
        if (window.visualViewport) window.visualViewport.removeEventListener('resize', rafUpdateVH)
      }
    }

    // Иногда нужно 2 обновления
    requestAnimationFrame(() => {
      updateVH()
      setTimeout(updateVH, 500)
    })

    addListeners()

    return () => removeListeners()
  }, [])
}

export { useDynamicVH }
